import { useState } from "react";

/**
 * Gets or sets the current auth state, also stored in localstorage
 */
export function useAuthState() {
  //AUTH STATE
  const setAuth = (authed: boolean) => {
    if (authed) {
      localStorage.setItem("IS_AUTHED", "true");
      setAuthState(true);
    } else {
      localStorage.removeItem("IS_AUTHED");
      setAuthState(false);
    }
  };
  const loadAuth = () => {
    const authed = localStorage.getItem("IS_AUTHED");
    return authed ? true : false;
  };
  const [authState, setAuthState] = useState<boolean>(loadAuth());

  const hooks: [boolean, (auth: boolean) => void] = [authState, setAuth];
  return hooks;
}
